const React = require('react');

/* eslint-disable */
module.exports = (props) => (
  <svg
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={'dB fillF>path ' + (props.className || '')}
  >
    <path
      d="M6.85937 13L8.63875 11.3289L4.77875 7.67945L15 7.67945L15 5.32055L4.77875 5.32054L8.63875 1.67109L6.85938 2.41998e-07L-1.3391e-06 6.5L6.85937 13Z"
    />
  </svg>
);
